<template>
  <div class="list_item">
    <p class="title">{{title}}</p>
    <van-grid :column-num="list.length < 3 ? list.length : 3" :border="false" :clickable="true">
      <van-grid-item id="investment-van-grid-item" v-for="(item,index) in list" :key="index">
        <p class="name">{{item.name}}</p>
        <p class="amount">{{item.amount}}</p>
      </van-grid-item>
      
    </van-grid>
  </div>
</template>

<script>

export default {
  name: "listItem",
  components: {},
  props: {
    title: String,
    list: Array
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.list_item {
    background: #FFFFFF;
    padding: 12px;
    border-radius: 3px;
    margin-top: 12px;
    .title{
        color: #333333;
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        padding-bottom: 4px;
    }
    .name{
      font-size: 12px;
      color: #333333;
      line-height: 17px;
    }
    .amount{
      color: #36B374;
      font-size: 20px;
      line-height: 28px;
      font-weight: bold;
    }
    
}
#investment-van-grid-item{
      
      /deep/.van-grid-item__content--center{
        padding: 15px 0 0 !important;
      }
    }
</style>